export function createDelayedCommandTimerClient(transport) {
    return {
        /**
         * GET /health/live
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getLiveness(options) {
            return transport.request({
                method: "GET",
                path: "/health/live",
                options,
            });
        },
        /**
         * GET /health/ready
         *
         * The contract declares no response schema for this operation, so the
         * result is `unknown` and the caller must narrow it. That is the
         * contract's gap, not the generator's.
         */
        getReadiness(options) {
            return transport.request({
                method: "GET",
                path: "/health/ready",
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/delayed-timers
         *
         * Requires scope: delayed-timers:write
         */
        createDelayedTimer(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/delayed-timers/{timerId}
         *
         * Requires scope: delayed-timers:read
         */
        getDelayedTimer(tenantId, timerId, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers/${encodeURIComponent(timerId)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/delayed-timers/{timerId}/cancel
         *
         * Requires scope: delayed-timers:cancel
         */
        cancelDelayedTimer(tenantId, timerId, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers/${encodeURIComponent(timerId)}/cancel`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/delayed-timers/claims
         *
         * Requires scope: delayed-timers:worker
         */
        claimDelayedTimers(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers/claims`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/delayed-timers/{timerId}/heartbeat
         *
         * Requires scope: delayed-timers:worker
         */
        heartbeatDelayedTimer(tenantId, timerId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers/${encodeURIComponent(timerId)}/heartbeat`,
                body,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/delayed-timers/{timerId}/outcomes
         *
         * Requires scope: delayed-timers:worker
         */
        completeDelayedTimerAttempt(tenantId, timerId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/delayed-timers/${encodeURIComponent(timerId)}/outcomes`,
                body,
                options,
            });
        },
        /**
         * List every tenant's delayed timers, as a command type, a due instant and a state
         *
         * Requires scope: delayed-timers:platform:read
         */
        listPlatformDelayedTimers(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/delayed-timers",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=delayed-command-timer.js.map